<template>
  <div class="esp_page_header" :style="{padding: padding}">
    <div class="esp_header_left">
      <slot></slot>
    </div>
    <div class="esp_header_right" :style="{width: btnWidth, paddingLeft: gutter}">
      <slot name="btn"></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'EspPageHeader',
    props: {
      btnWidth: {              // 按钮区域宽度
        type: String,
        default: 'auto'
      },
      padding: {               // 整体的边距
        type: String,
        default: '10px 10px 0px 10px'
      },
      gutter: {               // 查询条件和按钮之间的间隙
        type: String,
        default: '10px'
      }
    }
  }
</script>

<style scoped lang="less">
  .esp_page_header {
    display: flex;

    .esp_header_left {
      flex: 1;
    }

    .esp_header_right {
      text-align: right;

      .el-button {
        margin-bottom: 10px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/EspPageHeader.vue